export default {
    // HOST_WS : "ws://localhost:3111/",
    // HOST_WSM : "ws://localhost:3211/",

    // MY_APP_PUBLIC_IP: "http://localhost:3082/",
    // FILE_PATH: "http://localhost:3083/files/",
    // HOST_API: "http://localhost:3083/",

    // MY_APP_PUBLIC_IP: "http://61.91.124.155:3010/",
    // FILE_PATH: "http://61.91.124.155:3011/files/",
    // HOST_API: "http://61.91.124.155:3011/",

    // MY_APP_PUBLIC_IP: "http://172.22.1.53:3017",
    // FILE_PATH: "http://172.22.1.53:3018/files/",
    // HOST_API: "http://172.22.1.53:3018/",

    // MY_APP_PUBLIC_IP: "http://61.91.120.21:3082/",
    // FILE_PATH: "http://61.91.120.21:3083/files/",
    // HOST_API: "http://61.91.120.21:3083/",

    // demo dns ==================================
    MY_APP_PUBLIC_IP: "https://demo-app-sss.mocap.co.th/",
    FILE_PATH: "https://demo-app-sss.mocap.co.th/sssapi/files/",
    HOST_API: "https://demo-app-sss.mocap.co.th/sssapi/",
}